import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions } from '@angular/http';

import { Observable } from 'rxjs/Observable'
import 'rxjs/Rx';

import { API_URL, API_Tenant, API_GetTenant, API_NewTenant, API_GetAllTenants, API_TenantID, API_UpdateTenant } from './apiconfig';
import { Tenant, CodedLookup } from './index.model';

//import { Http_Header_Request_Options } from '../core/httpheader';
import { HttpHeader } from '../core/httpheader';

@Injectable()
export class TenantService {

    private apiUrl: string;

    private requestHeader: HttpHeader = new HttpHeader();
    private Http_Header_Request_Options: RequestOptions;

    constructor(private _http: Http) {
        this.apiUrl = API_URL;
    }

    // Get Agency Info

    getTenant(TenantName: string): Promise<Tenant> {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http
            .get(this.apiUrl + API_Tenant + "/" + API_GetTenant + "/" + TenantName, this.Http_Header_Request_Options)
            .toPromise()
            .then((response) => {
                return response.json() as Tenant;
            })
            .catch(this.handleError);
    }

    // Get all the Tenant Lists
    getAllTenants() {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http
            .get(this.apiUrl + API_Tenant + "/" + API_GetAllTenants, this.Http_Header_Request_Options)
            .toPromise()
            .then((response) => {
                return response.json() as Tenant[];
            })
            .catch(this.handleError);
    }

    // Get Tenant Details based on the TenantID
    getTenantByID(TenantID: string): Promise<Tenant> {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http
            .get(this.apiUrl + API_Tenant + "/" + API_TenantID + "/" + TenantID, this.Http_Header_Request_Options)
            .toPromise()
            .then((response) => {
                return response.json() as Tenant;
            })
            .catch(this.handleError);
    }

    getDBName() {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http
            .get(this.apiUrl + API_Tenant + "/GetAllDbList", this.Http_Header_Request_Options)
            .toPromise()
            .then((response) => {
                return response.json() as CodedLookup;
            })
            .catch(this.handleError);
    }

    // Adding New Configuration
    AddTenant(model: Tenant) {
        let body = model;
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();

        return this._http.post(this.apiUrl + API_Tenant + "/" + API_NewTenant, body, this.Http_Header_Request_Options)
            .map((res: Response) => res);
    }

    // Updating the Tenant Configuration
    UpdateTenant(model: Tenant) {
        let body = model;
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();

        return this._http.put(this.apiUrl + API_Tenant + "/" + API_UpdateTenant, body, this.Http_Header_Request_Options)
            .map((res: Response) => res);
    }

    // Handle Error

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/tenant.service.ts